export default {
  state: {
    customsTariffNumbers: [],
    loading: false,
  },
  getters: {
    customsTariffNumbers: state => state.customsTariffNumbers,
    loading: state => state.loading,
  },
  mutations: {
    setCustomsTariffNumbers(state, customsTariffNumbers) {
      state.customsTariffNumbers = customsTariffNumbers;
    },
    addCustomsTariffNumber(state, customsTariffNumber) {
      state.customsTariffNumbers.push(customsTariffNumber);
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const customsTariffNumbers = await axios.get('api/customs-tariff-numbers');
        commit('setCustomsTariffNumbers', customsTariffNumbers);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/customs-tariff-numbers/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
        const response = await axios.post('api/customs-tariff-numbers', payLoad);
        commit('addCustomsTariffNumber', response.data);
        return response.data;
    },

    async update({ commit }, payLoad) {
        await axios.put('api/customs-tariff-numbers', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/customs-tariff-numbers/' + id);
    }
  },
};
